import { useStore } from './useStore'

const useLeaseTypeLoan = () => {
    const { state } = useStore();
    return state.borrower.HasLiabCov;
}

export { useLeaseTypeLoan }